import { render } from "./DiscordAdd.vue?vue&type=template&id=0bb98e88&ts=true"
import script from "./DiscordAdd.vue?vue&type=script&lang=ts"
export * from "./DiscordAdd.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\brad\\Dropbox\\Programnming\\dapp\\crypto-notifi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__